// src/lib/personalTasks.js — the personal task list (Aaron, 2026-10-20:
// "things that are important for me should go in my tasks … Janet should know
// them but they do not go out to the rest of Chatrone").
//
// Pure. Stored in public.personal_tasks (migration 20261020_personal_tasks.sql),
// never in `tasks`, so no team surface can read one. Who sees whose list is
// public.personal_access, enforced by RLS.

export const PERSONAL_TASK_STATUSES = ['open', 'done']

/** Open first; by due date (undated last); newest first among equals. */
export function sortPersonalTasks(rows) {
  return [...(rows || [])].sort((a, b) => {
    if (a.status !== b.status) return a.status === 'open' ? -1 : 1
    const ad = a.due_date || '9999-12-31'
    const bd = b.due_date || '9999-12-31'
    if (ad !== bd) return ad < bd ? -1 : 1
    return String(b.created_at || '').localeCompare(String(a.created_at || ''))
  })
}

/** A row ready to insert, or { error }. */
export function personalTaskRow({ title, notes, dueDate, ownerId, createdBy, source = 'manual' }) {
  const t = String(title || '').replace(/\s+/g, ' ').trim()
  if (!t) return { error: 'A personal task needs a title.' }
  if (!ownerId) return { error: 'Whose list is this for?' }
  const due = dueDate && /^\d{4}-\d{2}-\d{2}$/.test(String(dueDate).slice(0, 10)) ? String(dueDate).slice(0, 10) : null
  return {
    row: {
      owner_id: ownerId,
      title: t.slice(0, 300),
      notes: String(notes || '').trim().slice(0, 4000) || null,
      due_date: due,
      created_by: createdBy || null,
      source: source === 'janet' ? 'janet' : 'manual',
    },
  }
}

/** The lists this viewer may see: their own first, then those they assist. */
export function visibleLists(viewerId, accessRows, nameOf = id => id) {
  const lists = viewerId ? [{ ownerId: viewerId, label: 'Mine' }] : []
  for (const a of accessRows || []) {
    if (a.reader_id === viewerId && a.owner_id !== viewerId && !lists.some(l => l.ownerId === a.owner_id)) {
      lists.push({ ownerId: a.owner_id, label: nameOf(a.owner_id) })
    }
  }
  return lists
}

export function isOverdue(row, today = new Date().toISOString().slice(0, 10)) {
  return row?.status === 'open' && !!row.due_date && row.due_date < today
}
